import { render, staticRenderFns } from "./OpenServicesMenu.vue?vue&type=template&id=f3442800&scoped=true&"
import script from "./OpenServicesMenu.vue?vue&type=script&lang=js&"
export * from "./OpenServicesMenu.vue?vue&type=script&lang=js&"
import style0 from "./OpenServicesMenu.vue?vue&type=style&index=0&id=f3442800&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3442800",
  null
  
)

export default component.exports